import AuthService from '@/services/auth.service'
/**
 * 'AccessControl.service'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default {
  check (to) {
    return new Promise((resolve, reject) => {
      if (to.meta && to.meta.access && Array.isArray(to.meta.access)) {
        if (to.meta.access.indexOf('*') > -1) {
          resolve()
        } else {
          AuthService.isAuthenticated() ? resolve() : reject(new Error('Debe de autenticarse para acceder a esta ruta'))
        }
      } else {
        AuthService.isAuthenticated() ? resolve() : reject(new Error('Debe de autenticarse para acceder a esta ruta'))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/access-control.service.js